"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
const core_1 = require("@angular/core");
const common_1 = require("@angular/common");
const enums_1 = require("../@shared-types/vehicle/enums");
const bodycode_1 = require("../shared/models/bodycode/bodycode");
const vehicle_1 = require("../shared/models/vehicle/vehicle");
const opportunity_1 = require("../shared/models/opportunity/opportunity");
const users_service_1 = require("../../../shared/users/users.service");
const toast_service_1 = require("../../../ui-components/toast/toast.service");
/** With this component a user can manually create a `Opportunity`. This
 * can only be made for vehicles, that (not yet) exist. We call them `DummyVehicle`.
 * The user will be presented a list of options to select make, model etc. and lastly
 * a `Bodycode`. We use the latter to create a `DummyVehicle`.
 * The user furthermore can select `FeaturePackets` for the created `DummyVehicle`.
 */
let OpportunityFormComponent = class OpportunityFormComponent {
    constructor(bodycodeModel, vehicleModel, opportunityModel, userService, location, toastService) {
        this.bodycodeModel = bodycodeModel;
        this.vehicleModel = vehicleModel;
        this.opportunityModel = opportunityModel;
        this.userService = userService;
        this.location = location;
        this.toastService = toastService;
        this.manufacturer = enums_1.EVehicleManufacturer.FCA;
        this.manualVehicleOptions = null;
        this.sending = false;
        /** Options we present the user to select from. */
        this.filteredOptions = {
            makes: [],
            bodycodes: {},
            models: [],
            modelyears: [],
            featurePackets: [],
        };
        /** The values, the user has selected. */
        this.selectedOptions = {
            bodycode: '', make: '', model: '', modelyear: '', featurePackets: {}, customerId: null,
        };
        /** Gett all possible bodycodes (makes, models etc.) from the server
         * to let the user select which vehicle to create as a dummy. */
        this.getVehicleOptions = () => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.bodycodeModel.getManualBodycodes(this.manufacturer);
            this.manualVehicleOptions = res;
            this.filterOptions();
        });
        /** When the user finally has selected a `Bodycode`, we use it to
         * retreive all possible `FeaturePackets` to let the user select them also. */
        this.getFeaturePackets = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.selectedOptions.bodycode)
                return;
            this.filteredOptions.featurePackets = yield this.bodycodeModel.getFeaturePacketsForBodycode(this.selectedOptions.bodycode);
        });
        /**
         * First we create a `DummyVehicle` with the data we have collected from the user.
         * The returned `vehicleId` is then used to open a new `Opperrunity` to which
         * we redirect the user on success for further processing.
         */
        this.addOpportunity = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.selectedOptions.bodycode
                || !this.selectedOptions.customerId
                || !this.selectedOptions.featurePackets)
                return;
            const selectedFeaturePackets = Object.entries(this.selectedOptions.featurePackets)
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                .filter(([i, selected]) => selected)
                .map(([id]) => this.filteredOptions.featurePackets.find((f) => String(f._id) === id))
                .filter((v) => !!v);
            /** Create a `DummyVehicle` to be used later */
            const dummyVehicleRequest = {
                bodycode: this.selectedOptions.bodycode,
                dummyVehicle: true,
                manufacturer: this.manufacturer,
                featurePackets: selectedFeaturePackets,
            };
            const dummyVehicleResponse = yield this.vehicleModel.postDummyVehicle(dummyVehicleRequest);
            const opportunityRequest = {
                customerId: this.selectedOptions.customerId,
                userId: this.userService.currentUserId(),
                vehicleId: String(dummyVehicleResponse.vehicleId),
                dummyVehicle: true,
            };
            const opportunityResponse = yield this.opportunityModel.post(opportunityRequest);
            this.location.go(`/opportunities/opportunity/${String(opportunityResponse.id)}`);
        });
        /** Gets called each time a selected value has changed.
         * Depending on what changed, all subsequent filter options must be
         * reassigned. eg. when make changes, we need to reassign all selectable
         * models. */
        this.filterOptions = (filteredValue) => __awaiter(this, void 0, void 0, function* () {
            if (!this.manualVehicleOptions)
                return;
            /** Only assign makes */
            if (!filteredValue) {
                this.filteredOptions.makes = [...new Set(this.manualVehicleOptions.bodycodes.map((v) => v.make))]
                    .sort((a, b) => a.localeCompare(b));
            }
            if (filteredValue === 'make') {
                const options = this.manualVehicleOptions.bodycodes
                    .filter((v) => v.make === this.selectedOptions.make);
                this.filteredOptions.models = [...new Set(options.map((v) => v.model))]
                    .sort((a, b) => a.localeCompare(b));
                this.selectedOptions.model = '';
                this.selectedOptions.modelyear = '';
                this.selectedOptions.bodycode = '';
            }
            if (filteredValue === 'model') {
                const options = this.manualVehicleOptions.bodycodes
                    .filter((v) => (v.make === this.selectedOptions.make)
                    && v.model === this.selectedOptions.model);
                this.filteredOptions.modelyears = [...new Set(options.map((v) => v.modelyear))].map((c) => String(c))
                    .sort((a, b) => a.localeCompare(b));
                this.selectedOptions.modelyear = '';
                this.selectedOptions.bodycode = '';
            }
            if (filteredValue === 'modelyear') {
                this.selectedOptions.bodycode = '';
                const options = this.manualVehicleOptions.bodycodes
                    .filter((v) => (v.make === this.selectedOptions.make)
                    && v.model === this.selectedOptions.model
                    && v.modelyear === parseInt(this.selectedOptions.modelyear, 10))
                    .sort((a, b) => a.modelDescription.localeCompare(b.modelDescription));
                this.filteredOptions.bodycodes = {};
                options.forEach((o) => {
                    this.filteredOptions.bodycodes[o.bodycode] = `${o.modelDescription} (${o.bodycode}) <small>${o.fuelTranslation} ${o.drivetrainTranslation} ${o.powerTranslation}</small>`;
                });
                this.selectedOptions.bodycode = '';
            }
            if (filteredValue === 'bodycode') {
                yield this.getFeaturePackets();
            }
        });
        this.submitForm = () => __awaiter(this, void 0, void 0, function* () {
            this.sending = true;
            yield this.addOpportunity()
                .catch((e) => {
                // eslint-disable-next-line no-console
                console.error(e);
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Die Erstellung der Verkaufschance ist gescheitert.');
            });
            this.sending = false;
        });
        this.getVehicleOptions();
    }
};
OpportunityFormComponent = __decorate([
    (0, core_1.Component)({
        selector: 'opportunity-form',
        templateUrl: require('./opportunity-form.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof bodycode_1.BodycodeModel !== "undefined" && bodycode_1.BodycodeModel) === "function" ? _a : Object, typeof (_b = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _b : Object, typeof (_c = typeof opportunity_1.OpportunityModel !== "undefined" && opportunity_1.OpportunityModel) === "function" ? _c : Object, typeof (_d = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _d : Object, typeof (_e = typeof common_1.Location !== "undefined" && common_1.Location) === "function" ? _e : Object, typeof (_f = typeof toast_service_1.ToastService !== "undefined" && toast_service_1.ToastService) === "function" ? _f : Object])
], OpportunityFormComponent);
exports.default = OpportunityFormComponent;
